export default __webpack_public_path__ + "static/media/logo.e18a5263.png";